import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const SignatureElement = (props) => {
  return (
    <div className="signature-element">
      <div className="signed">
        <div className="signed-text">Signed</div>
      </div>
      <div>
        <b>{props.authoredBy}</b> {moment(props.signedAt).format('HH:mm on MMM D, YYYY')}
      </div>
    </div>
  );
};

export default SignatureElement;
